export const WEEKDAYS = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'] as const

export type Weekday = typeof WEEKDAYS[number]

export function isWholeWeek(weekdays?: Array<Weekday>): boolean {
  return (
    !Array.isArray(weekdays) ||
    weekdays.length === 0 ||
    (weekdays.length === 7 &&
      weekdays.includes('MON') &&
      weekdays.includes('TUE') &&
      weekdays.includes('WED') &&
      weekdays.includes('THU') &&
      weekdays.includes('FRI') &&
      weekdays.includes('SAT') &&
      weekdays.includes('SUN'))
  )
}
